const ToolboxInfo = {
  maxInstances: {
    controls_repeat_internal: 3,
    character_motion_move: 2,
    character_motion_jump: 1,
    character_motion_turn_left: 1,
  },
  json: {
    kind: "categoryToolbox",
    contents: [
      {
        kind: "category",
        toolboxitemid: "category",
        contents: [
          {
            kind: "block",
            type: "controls_repeat_internal",
            extraState: {
              max: 2,
            },
          },
          {
            kind: "block",
            type: "character_motion_move",
          },
          {
            kind: "block",
            type: "character_motion_jump",
          },
          {
            kind: "block",
            type: "character_motion_turn_left",
          },
        ],
      },
    ],
  },
};

export default ToolboxInfo;
